import { CHeader } from './CHeader.js';
import { CHeaderBrand } from './CHeaderBrand.js';
import { CHeaderDivider } from './CHeaderDivider.js';
import { CHeaderNav } from './CHeaderNav.js';
import { CHeaderText } from './CHeaderText.js';
import { CHeaderToggler } from './CHeaderToggler.js';

const CHeaderPlugin = {
    install: (app) => {
        app.component(CHeader.name, CHeader);
        app.component(CHeaderBrand.name, CHeaderBrand);
        app.component(CHeaderDivider.name, CHeaderDivider);
        app.component(CHeaderNav.name, CHeaderNav);
        app.component(CHeaderText.name, CHeaderText);
        app.component(CHeaderToggler.name, CHeaderToggler);
    },
};

export { CHeader, CHeaderBrand, CHeaderDivider, CHeaderNav, CHeaderPlugin, CHeaderText, CHeaderToggler };
//# sourceMappingURL=index.js.map
